function getLabels (data) {
  const labels = []
  data.forEach(item => {
    labels.push(item.timeSlot)
  })
  return labels
}

function getCount (data) {
  const count = []
  data.forEach(item => {
    count.push(item.count)
  })
  console.log(count)
  return count
}

export const getVerticalBarChartData = (themes, data) => ({
  labels: getLabels(data),
  datasets: [
    {
      label: 'USA',
      backgroundColor: themes.primary,
      borderColor: 'transparent',
      data: getCount(data),
    },
  ],
})
